import {
  SET_TRANSACTION_PASSWORD_SUCCESS,
  SET_TRANSACTION_PASSWORD_FAILED,
  RESET_SET_TRANSACTION_PASSWORD,
  LOADING_SET_TRANSACTION_PASSWORD,
  NETWORK_ERROR_SET_TRANSACTION_PASSWORD,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  data: {},
  networkError: "",
  invalidRequest: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_SET_TRANSACTION_PASSWORD: {
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case SET_TRANSACTION_PASSWORD_FAILED: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        data: action.payload,
      };
    }
    case SET_TRANSACTION_PASSWORD_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: action.payload,
      };
    }
    case NETWORK_ERROR_SET_TRANSACTION_PASSWORD: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        networkError: "Something went wrong!",
        data: {},
      };
    }
    case RESET_SET_TRANSACTION_PASSWORD: {
      return (state = initialState);
    }

    default:
      return state;
  }
};
